export default "__VITE_ASSET__G_8drYLS__"